/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import forEach from "lodash/forEach";
import {formats} from "@auex/utilities";
import FrontendLocaleManager from "@novivia/localization/FrontendLocaleManager";
import merge from "lodash/merge";
import {namespaces} from "../locales/namespaces.json5";

const {number} = formats;

const isInBrowser = process.browser && !__PRERENDER__;

export const localeManager = new FrontendLocaleManager({
  i18nextConfiguration: {
    customLoader: require("../locales/getLocales"),
    enableLocalStorage: __PROD__,
    fallbackNamespace: "widget-common",
    instantInitialization: false,
    namespaceList: namespaces,
  },
  i18nextOptions: {
    useCache: isInBrowser,
    useLanguageDetector: isInBrowser,
  },
});

if (isInBrowser) {
  // If we are dealing with a new version, clear local storage locales and set
  // the new version.
  if (localStorage.getItem("version") !== AuctionEx.version) {
    forEach(AuctionEx.languages, (langName, langKey) => {
      localStorage.removeItem(`i18n_${langKey}`);
    });

    localStorage.setItem("version", AuctionEx.version);
  }
}

export const __ = ::localeManager.getLanguageKey;

export function getLanguage() {
  return localeManager.getCurrentLanguage();
}

const numberSettings = new Map();

export function formatNumber(numberToFormat, extraSettings) {
  if (!extraSettings) {
    return localeManager.formatNumber(numberToFormat);
  }

  console.warn(
    "These arguments for 'formatNumber' are deprecated:",
    extraSettings,
  );

  const languageCode = __("language::code");
  let settings;

  if (numberSettings.has(languageCode)) {
    settings = numberSettings.get(languageCode);
  } else {
    settings = merge(
      {},
      number.getAccountingSettings().number,
      __("language::accounting").number,
    );
    numberSettings.set(languageCode, settings);
  }

  return number.formatNumber({
    number: numberToFormat,
    settings: merge(
      {},
      settings,
      extraSettings,
    ),
  });
}

export const formatFilesize = ::localeManager.formatFilesize;



// WEBPACK FOOTER //
// ../language.js